export const isEditableEventTarget = (target) => {
  if (!target) return false;
  const tagName = String(target.tagName || "").toLowerCase();
  if (tagName === "input" || tagName === "textarea") return true;
  return target.isContentEditable === true;
};

export const shouldHandleWorkoutCardShiftEnterShortcut = ({
  event,
  isEditMode,
  mode = "planification",
  activeFloatingSearchId = null,
  addExerciseInstanceId = null,
}) => {
  if (!isEditMode) return false;
  if (event?.key !== "Enter" || event?.shiftKey !== true) return false;
  if (isEditableEventTarget(event?.target)) return false;

  const isLibraryMode = mode === "library";
  if (
    isLibraryMode &&
    addExerciseInstanceId &&
    activeFloatingSearchId === addExerciseInstanceId
  ) {
    return false;
  }

  return true;
};
